<template>
    <main>
        <div class="grid justify-items-start max-w-3xl mx-auto mt-16">
          <h3 class="mb-2 font-semibold tracking-wider">Udyam Verification</h3>
          <div class="bg-gray-100 px-8 py-12 rounded-md">
            <udyam-verification-component/>
          </div>
        </div>
    </main>
</template>
<script>
import UdyamVerificationComponent from '../components/UdyamVerification.vue';

  export default {
    name: 'UdyamVerification',
    components: {
        UdyamVerificationComponent
    },
    data() {
      return {
      };
    },
    methods: {
    }
  };
</script>
<style scoped>
main {
  height: 100vh;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 20px;
  border: 2px solid transparent;
}
</style>
